import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { selectProfile } from './profile.selector.ts';

export const selectProfileAge = createMemoizedSelector(
  selectProfile,
  (currentProfile): number => currentProfile?.age ?? 0
);
